// extracted by mini-css-extract-plugin
module.exports = {"noScrollbarWithDescendants":"scrollbar_noScrollbarWithDescendants__x7hDA","noScrollbar":"scrollbar_noScrollbar__jj64N","customScrollbar":"scrollbar_customScrollbar__1hu6u"};